import React, { useMemo } from "react";

import Icon from "./Icon";
import joinClassNames from "../helpers/joinClassNames";
import {UncontrolledTooltip} from "reactstrap";

const STRENGTH_PATTERNS = [/.{8,}/, /(?=.*\d)/, /(?=.*[A-Z])/];

const STRENGTH_STYLES = [
    {
        first: "bg-transparent",
        second: "bg-transparent",
        third: "bg-transparent",
        textColor: "text-[#FF3C00]",
        iconColor: "fill-[#FF3C00]",
        label: "Weak",
    },
    {
        first: "bg-[#FF3C00]",
        second: "bg-[#DDE2E3]",
        third: "bg-[#DDE2E3]",
        textColor: "text-[#FF3C00]",
        iconColor: "fill-[#FF3C00]",
        label: "Weak protection",
    },
    {
        first: "bg-[#FF7F00]",
        second: "bg-[#FF7F00]",
        third: "bg-[#DDE2E3]",
        textColor: "text-[#FF7F00]",
        iconColor: "fill-[#FF7F00]",
        label: "Average",
    },
    {
        first: "bg-[#00C56F]",
        second: "bg-[#00C56F]",
        third: "bg-[#00C56F]",
        textColor: "text-[#00C56F]",
        iconColor: "fill-[#00C56F]",
        label: "Strong",
    },
];

const defaultStyles =
    "w-[88px] h-1 rounded transition-colors duration-300";

const getPasswordStrength = password => {
    let successChecks = [];
    STRENGTH_PATTERNS.forEach(pattern => {
        successChecks = [...successChecks, pattern.test(password)];
    });
    return successChecks;
};

function TooltipOverlay({ checkList }) {
    return (
        <section className="d-flex flex-column">
            {checkList.map(({ isSuccess, label }, index) => (
                <section
                    className={joinClassNames(
                        "d-flex align-items-center whitespace-nowrap",
                        index && "mt-1",
                        isSuccess ? "text-success" : "text-secondary"
                    )}
                    key={index}
                >
                    <Icon
                        icon={isSuccess ? "checkMark" : "circle"}
                        className="min-w-[18px] "
                    />
                    <span className="font-size-16 ms-2">{label}</span>
                </section>
            ))}
        </section>
    );
}

export default function PasswordStrength({ password = "" }) {
    const passwordChecks = getPasswordStrength(password);
    const currentState =
        STRENGTH_STYLES[passwordChecks.filter(check => !!check).length];

    const checkList = useMemo(
        () => [
            { isSuccess: passwordChecks[0], label: "at least 8 symbols" },
            { isSuccess: passwordChecks[1], label: "at least 1 digit" },
            { isSuccess: passwordChecks[2], label: "at least 1 upper letter" },
        ],
        [currentState, password]
    );

    return (
        <section className="d-flex align-items-center justify-content-between mt-1">
            <div className="d-flex align-items-center ">
                <div className={joinClassNames(defaultStyles, currentState.first)} />
                <div
                    className={joinClassNames("mx-2", defaultStyles, currentState.second)}
                />
                <div className={joinClassNames(defaultStyles, currentState.third)} />
            </div>

            <section
                className={joinClassNames(
                    "ml-auto transition-colors duration-300 d-flex align-items-center",
                    currentState.textColor
                )}
            >
                <Icon
                    id="passwordStrength"
                    icon="infoCirclePassword"
                    className={joinClassNames(
                        "me-1 ms-2",
                        currentState.iconColor
                    )}
                />
                {currentState.label}
                <UncontrolledTooltip
                    target="passwordStrength"
                    placement="bottom"
                >
                    <TooltipOverlay checkList={checkList} />
                </UncontrolledTooltip>
            </section>
        </section>
    );
}
